import React, { useEffect, useLayoutEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    Switch,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Typography,
    Tabs,
    Tab,
    TextField,
    Popper,
    ClickAwayListener,
    Paper,
    Chip,
    InputAdornment,
    Tooltip,
    Autocomplete,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import { Clear } from "@mui/icons-material";
import { errorToast } from "../../helpers";
import Pagination from "../../components/Pagination";
import Loader from "../../helpers/constants/Loader";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { useLazyGetAllTypeOfCompaniesQuery } from "../../services/users";
import { LISTING_TYPE, ROLE, XML_PROPERTY_TYPE } from "../../constants/enums";
import { useLazyGetXmlPropertiesQuery } from "../../services/property";
import { useLazyGetAllActionTrackerForXmlQuery } from "../../services/actionTracker";



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ManageXML = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [getAllProperties] = useLazyGetXmlPropertiesQuery();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [companies, setCompanies] = useState<any>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [getApprovedCompany] = useLazyGetAllTypeOfCompaniesQuery();
    const [dataCount, setDataCount] = useState<any>({
        allProperties: 0,
        newlyAddedProperties: 0,
        previouslyPublishedProperties: 0,
        temporaryUnpublishedProperties: 0,
        xmlDeletedProperties: 0,
        listingActionTrackerXmlProperties: 0
    })

    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRows([]);
    };
    const { state } = useLocation();
    const [value, setValue] = React.useState(0);
    console.log(value, "value");


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setPage(1);
    };

    const [valueInnerTab, setValueInnerTab] = React.useState(0);

    // const handleChangeForInnerTab = (event: React.SyntheticEvent, newValue: number) => {
    //     setValueInnerTab(newValue);
    //     setPage(1);
    // };

    const [open1, setOpen1] = useState(false); // Control calendar visibility
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [selectedChip, setSelectedChip] = useState("");
    const [month, setMonth] = useState(new Date());
    const [listingActionTracker] = useLazyGetAllActionTrackerForXmlQuery();
    const [range, setRange] = useState<{
        from: Date | undefined;
        to: Date | undefined;
    }>({
        from: undefined,
        to: undefined,
    });

    const handleClose = () => {
        setOpen1(false);
    };


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen1(true);
    };

    function formatNumberWithCommas(value: string | number) {
        const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
        const [integer, decimal] = valueStr.split('.');
        const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
        return result;
    }

    const fetchCompanies = async () => {
        try {
            const response = await getApprovedCompany({
                role: ROLE.AGENCY
            }).unwrap();
            if (response.statusCode === 200) {
                setCompanies(response?.data || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getFormattedRange = () => {
        if (range?.from && range?.to) {
            return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
                range.to
            ).format("MM/DD/YYYY")}`;
        } else if (range?.from) {
            return moment(range.from).format("MM/DD/YYYY");
        }
        return "";
    };

    const handleSelect = (selectedRange: any) => {
        if (selectedRange === undefined) {
            setRange({ from: undefined, to: undefined });
        } else {
            setRange(selectedRange);
        }
    };

    const handleChipClick = (value: any) => {
        if (value === selectedChip) {
            setSelectedChip("");
            setRange({ from: undefined, to: undefined });
            setMonth(moment().toDate());
            return;
        }
        setSelectedChip(value);

        let newRange = { from: moment().toDate(), to: moment().toDate() };
        const today = moment();

        if (value === "lastMonth") {
            newRange = {
                from: moment().subtract(1, "months").startOf("month").toDate(),
                to: moment().subtract(1, "months").endOf("month").toDate(),
            };
        } else if (value === "lastWeek") {
            newRange = {
                from: moment().subtract(7, "days").startOf("day").toDate(),
                to: today.toDate(),
            };
        } else if (value === "lastYear") {
            newRange = {
                from: moment().subtract(1, "years").startOf("year").toDate(),
                to: moment().subtract(1, "years").endOf("year").toDate(),
            };
        }
        setRange(newRange);
        setMonth(newRange.from);
    };

    const handleMonthChange = (newMonth: any) => {
        setMonth(newMonth);
    };


    const getListingActionTracker = async () => {
        setIsLoading(true)
        try {
            const res = await listingActionTracker({
                page: page,
                limit: limit,
                startDate: range?.from ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                endDate: range?.from === range?.to ? "" : range?.to ? moment(range?.to).utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                search: debouncedSearchTerm?.trim(),
                companyId: selectedCompany,
                isXmlUpdate: true
            }).unwrap();
            if (res?.statusCode === 200) {
                setRows(res?.data?.properties || [])
                setTotalCount(res?.data?.count)
                setDataCount({
                    allProperties: res?.data?.allProperties || 0,
                    newlyAddedProperties: res?.data?.newlyAddedProperties || 0,
                    previouslyPublishedProperties: res?.data?.previouslyPublishedProperties || 0,
                    temporaryUnpublishedProperties: res?.data?.temporaryUnpublishedProperties || 0,
                    xmlDeletedProperties: res?.data?.xmlDeletedProperties || 0,
                    listingActionTrackerXmlProperties: res?.data?.listingActionTrackerXmlProperties || 0
                })
            }
            setIsLoading(false)
        } catch (error: any) {
            setIsLoading(false)
            errorToast(error?.data?.message)
        }
    }

    const getRequest = async () => {
        setIsLoading(true)
        try {
            const res = await getAllProperties({
                page: page,
                limit: limit,
                startDate: range?.from ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                endDate: range?.from === range?.to ? "" : range?.to ? moment(range?.to).utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                search: debouncedSearchTerm?.trim(),
                propertyType: value === 0 ? XML_PROPERTY_TYPE.ALL : value === 1 ? XML_PROPERTY_TYPE.PREVIOUSLY_PUBLISHED_PROPERTIES : value === 2 ? XML_PROPERTY_TYPE.NEWLY_ADDED_PROPERTIES : value === 3 ? XML_PROPERTY_TYPE.XML_DELETED_PROPERTIES : value === 5 ? XML_PROPERTY_TYPE.UNPUBLISHED_XML_PROPERTIES : XML_PROPERTY_TYPE.ALL,
                companyId: selectedCompany
            }).unwrap();
            if (res?.statusCode === 200) {
                setRows(res?.data?.updatedXmlProperties?.rows || [])
                setTotalCount(res?.data?.updatedXmlProperties?.count)
                setDataCount({
                    allProperties: res?.data?.allProperties || 0,
                    newlyAddedProperties: res?.data?.newlyAddedProperties || 0,
                    previouslyPublishedProperties: res?.data?.previouslyPublishedProperties || 0,
                    temporaryUnpublishedProperties: res?.data?.temporaryUnpublishedProperties || 0,
                    xmlDeletedProperties: res?.data?.xmlDeletedProperties || 0,
                    listingActionTrackerXmlProperties: res?.data?.listingActionTrackerXmlProperties || 0
                })
            }
            setIsLoading(false)
        } catch (error: any) {
            setIsLoading(false)
            errorToast(error?.data?.message)
        }
    }


    useLayoutEffect(() => {
        if (state?.tab) {
            setValue(state?.tab);
        }
    }, []);
    useLayoutEffect(() => {
        if (state?.innerTab) {
            setValueInnerTab(state?.innerTab);
        }
    }, []);

    useEffect(() => {
        if (value === 4) {
            getListingActionTracker();
        } else {

            getRequest();
        }
    }, [value, page, limit, debouncedSearchTerm, range, selectedCompany])

    useEffect(() => {
        fetchCompanies();
    }, [])

    return (
        <div>
            <Loader isLoad={isLoading} />
            <div className="main_loyout">
                <div className="dashboard">
                    <h1 className="mn_hdng">Manage XML Properties</h1>
                </div>
                <Card className="cards">
                    <Box className="cards_header">
                        <Box className="cards_header_left">
                            <SearchBar2
                                value={searchTerm}
                                searchTerm={searchTerm}
                                onCross={() => setSearchTerm("")}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                onChange={(val: any) => {
                                    if (isValidInput(val.target.value)) {
                                        setSearchTerm(val.target.value);
                                        setTimeout(() => {
                                            setPage(1)
                                        }, 1000)
                                    }
                                }}
                            />
                            <div className="control_group" style={{ width: "250px" }}>
                                <TextField
                                    // label="Select Date Range"
                                    variant="outlined"
                                    hiddenLabel
                                    className="text_field-range"
                                    fullWidth
                                    onClick={handleClick}
                                    value={getFormattedRange()}
                                    placeholder="Select Date Range"
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: range?.from ? (
                                            <InputAdornment
                                                position="end"
                                                style={{ marginLeft: -50 }}
                                            >
                                                <IconButton
                                                    onClick={() => {
                                                        setRange({
                                                            from: undefined,
                                                            to: undefined,
                                                        });
                                                    }}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <Popper
                                open={open1}
                                anchorEl={anchorEl}
                                placement="bottom-start"
                                disablePortal
                                style={{
                                    position: "relative",
                                    zIndex: 1,
                                }}
                            >
                                <ClickAwayListener onClickAway={handleClose}>
                                    <Paper
                                        elevation={3}
                                        style={{ position: "relative", zIndex: 1 }}
                                    >
                                        <div
                                            style={{
                                                padding: 16,
                                                borderRadius: 10,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-around",
                                                }}
                                            >
                                                <Chip
                                                    label="Last Week"
                                                    variant={
                                                        selectedChip === "lastWeek" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastWeek")}
                                                />
                                                <Chip
                                                    label="Last Month"
                                                    variant={
                                                        selectedChip === "lastMonth" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastMonth")}
                                                />
                                                <Chip
                                                    label="Last Year"
                                                    variant={
                                                        selectedChip === "lastYear" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastYear")}
                                                />
                                            </div>

                                            <DayPicker
                                                className="react-day-picker"
                                                mode="range"
                                                selected={range}
                                                onSelect={handleSelect}
                                                // numberOfMonths={10}
                                                month={month}
                                                onMonthChange={handleMonthChange}
                                            // styles={{
                                            //   months: { display: "flex", gap: "16px" },
                                            //   month: { margin: 0 },
                                            // }}
                                            />
                                        </div>
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>
                            <div className="display_f" style={{ width: "250px", flexWrap: "nowrap" }}>
                                <Autocomplete
                                    options={companies || []}
                                    disableClearable
                                    getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Company"
                                            variant="outlined"
                                        />
                                    )}
                                    value={
                                        companies?.find(
                                            (it: any) => it?._id === selectedCompany
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        setSelectedCompany(newValue?._id || "");
                                    }}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option?._id === value?._id
                                    }
                                />
                                {selectedCompany ? (
                                    <IconButton onClick={() => setSelectedCompany("")} >
                                        <Clear />
                                    </IconButton>
                                ) : ("")}


                            </div>
                        </Box>

                    </Box>
                    <Box className="custom_tabs">
                        <Tabs
                            style={{ marginTop: "20px" }}
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >
                            <Tab
                                label={`All Properties (${dataCount?.allProperties})`}
                                {...a11yProps(1)}
                            />
                            <Tab
                                label={`Previous Properties (${dataCount?.previouslyPublishedProperties}) `}
                                {...a11yProps(2)}
                            />
                            <Tab
                                label={`Newly Added Properties (${dataCount?.newlyAddedProperties}) `}
                                {...a11yProps(3)}
                            />
                            <Tab
                                label={`Deleted Properties (${dataCount?.xmlDeletedProperties})`}
                                {...a11yProps(4)}
                            />
                            <Tab
                                label={`Listing action tracker (${dataCount?.listingActionTrackerXmlProperties})`}
                                {...a11yProps(5)}
                            />
                            <Tab
                                label={`Unpublished properties (${dataCount?.temporaryUnpublishedProperties})`}
                                {...a11yProps(6)}
                            />
                        </Tabs>
                        <div >
                            {/* <Tabs
                                style={{ marginTop: "20px" }}
                                value={valueInnerTab}
                                onChange={handleChangeForInnerTab}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="basic tabs example"
                                className="custom_tabs_links"
                            >
                                <Tab
                                    label={`Published `}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label={`Under Offer `}
                                    {...a11yProps(1)}
                                />
                                <Tab
                                    label={`Claimed `}
                                    {...a11yProps(2)}
                                />
                                <Tab
                                    label={`Unpublished `}
                                    {...a11yProps(3)}
                                />
                                <Tab
                                    label={`Temporary Unpublished `}
                                    {...a11yProps(4)}
                                />
                            </Tabs> */}
                            <TableContainer className="table_container">
                                <Box className="heading"></Box>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">S.No</TableCell>
                                            <TableCell align="center">Actions</TableCell>
                                            <TableCell>Property Id</TableCell>
                                            <TableCell>Reference No.</TableCell>
                                            <TableCell>Badges</TableCell>
                                            <TableCell>Image</TableCell>
                                            <TableCell>Property Name</TableCell>
                                            <TableCell>Quality Score</TableCell>
                                            <TableCell>Price</TableCell>
                                            <TableCell>Company Name</TableCell>
                                            <TableCell>Agent Name</TableCell>
                                            <TableCell>Listing Type</TableCell>
                                            <TableCell>Boost Property</TableCell>
                                            <TableCell>Property Category</TableCell>
                                            <TableCell>Property Type</TableCell>

                                            <TableCell>Date & time</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length == 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={9} align="center">
                                                    No Property found
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            rows?.map((row: any, i: any) => (
                                                <TableRow key={row?.i}>
                                                    <TableCell align="center">
                                                        {(page - 1) * 10 + i + 1}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box className="table_actions">

                                                            <Tooltip title="View Property details">
                                                                <IconButton
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/manage-xml-properties-details/${value === 4 ? row?.properties?._id : row?._id}`,
                                                                            { state: { tab: value, innerTab: valueInnerTab } }
                                                                        )
                                                                    }
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>


                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>{value === 4 ? row?.properties?.referenceId || "-" : row?.referenceId || "-"}</TableCell>
                                                    <TableCell>{value === 4 ? row?.properties?.import_reference_number : row?.import_reference_number || "-"}</TableCell>
                                                    <TableCell align="center">
                                                        <figure
                                                            className="user_img"
                                                        >

                                                            {value === 4 ? row?.properties?.isVerified : row?.isVerified ? (
                                                                <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                                                            ) : ("")}
                                                            {value === 4 ? row?.properties?.qualityScore >= 80 : row?.qualityScore >= 80 ? (
                                                                <img src="/static/images/verify_ico.svg" alt="" />
                                                            ) : ("")}
                                                            {value === 4 ? row?.properties?.isPropertyBoost : row?.isPropertyBoost ? (
                                                                <img src="/static/images/boost.png" alt="" />
                                                            ) : ("")}

                                                        </figure>
                                                    </TableCell>
                                                    <TableCell>
                                                        <figure

                                                            className="user_img"

                                                        >
                                                            <img
                                                                style={{ borderRadius: 0 }}
                                                                src={
                                                                    value === 4 ? row?.properties?.images?.[0] || `/static/images/product1.png` : row?.images?.[0] ? row?.images?.[0] : row?.interior?.[0] ? row?.interior?.[0] :
                                                                        `/static/images/product1.png`
                                                                }

                                                                alt=""
                                                            />


                                                        </figure>
                                                    </TableCell>
                                                    <TableCell style={{ minWidth: "220px", textWrap: "wrap" }} >{value === 4 ? row?.properties?.name || "-" : row?.name || "-"}</TableCell>
                                                    <TableCell>{value === 4 ? row?.properties?.qualityScore : row?.qualityScore || "-"}</TableCell>
                                                    <TableCell>
                                                        {row?.properties?.price || row?.price
                                                            ? formatNumberWithCommas(String(value === 4 ? row?.properties?.price : row?.price))
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell>{row?.companyId?.companyName ? row?.companyId?.companyName + " (" + row?.companyId?.referenceId + ")" : "-"}</TableCell>
                                                    <TableCell>{row?.agentId?.role === 5 || !row?.agentId?.role ? "-" : row?.agentId?.name + " (" + row?.agentId?.referenceId + ")"}</TableCell>
                                                    <TableCell>
                                                        {value === 4
                                                            ? LISTING_TYPE[row?.properties?.listingType] || "-"
                                                            : LISTING_TYPE[row?.listingType] || "-"}
                                                    </TableCell>
                                                    <TableCell>
                                                        {value === 4
                                                            ? row?.properties?.isPropertyBoost
                                                                ? "Yes"
                                                                : "No"
                                                            : row?.isPropertyBoost
                                                                ? "Yes"
                                                                : "No"}
                                                    </TableCell>
                                                    <TableCell>{value === 4 ? row?.category?.name || "-" : row?.categoryId?.name || "-"}</TableCell>
                                                    <TableCell>
                                                        {value === 4 ? row?.propertyType?.name || "-" : row?.propertyTypeId?.name || "-"}
                                                    </TableCell>
                                                    <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell>

                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {rows?.length > 0 ? (
                                <Pagination
                                    setPage={setPage}
                                    limit={limit}
                                    setLimit={setLimit}
                                    module={rows}
                                    page={page}
                                    onPageChange={onPageChange}
                                    totalPages={totalPages}
                                />
                            ) : (
                                ""
                            )}

                        </div>

                    </Box>

                </Card>
            </div>
        </div>
    );
};

export default ManageXML;


